/**
 * Gestion du statut de suivi électronique
 * d'une pièce fournisseur.
 *
 * Les statuts Dolibarr ne sont pas utilisés ici.
 */
import {
  Component,
  AfterViewInit,
  ViewEncapsulation,
  OnInit,
  OnDestroy
} from '@angular/core';

import {
  MAT_DIALOG_DATA,
  MatDialogRef
} from '@angular/material';

import { Inject } from '@angular/core';

import { Subscription } from 'rxjs';

import {
  FormBuilder,
  FormGroup,
  Validators
} from '@angular/forms';

import {
  INVOICE_STATUSES,
  InvoiceStatusDefinition,
  SUPPLIER_INVOICE_STATUS_REASONS,
  SupplierInvoiceModel,
  SupplierInvoiceStatusReason
} from '../../../../models/wks-suppliersInvoices.model';

import { TranslateService } from '../../../../../../services/translate.service';

import { LabelValue } from '../../../../../../models/data.model';


@Component({
  selector: 'mdi-supplier-invoice-change-status',
  templateUrl: './supplier-invoice-change-statut.component.html',
  styleUrls: ['./supplier-invoice-change-statut.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SupplierInvoiceChangeStatusComponent
  implements OnInit, AfterViewInit, OnDestroy {

  subscription: Subscription;
  modalTitle: string;
  invoiceTitle: string;
  invoice: SupplierInvoiceModel;
  invoiceStatusForm: FormGroup;
  invoiceStatusList: LabelValue[];
  reasonCodeList: SupplierInvoiceStatusReason[];
  currentStatus: string;
  newStatus: string;

  /**
   * Indique si le statut sélectionné
   * nécessite obligatoirement un motif.
   */
  requiresReason = false;


  constructor(
    private fb: FormBuilder,
    private _translate: TranslateService,
    private dialogRef:
      MatDialogRef<SupplierInvoiceChangeStatusComponent>,
    @Inject(MAT_DIALOG_DATA)
    data: any
    ) {
      this.modalTitle =
        data.title;
      this.invoiceTitle =
        data.contentMessage;
      this.invoice =
        data.data1;
      if (
        this.invoice === undefined
        || this.invoice === null
      ) {
        return;
      }

    this.currentStatus =
      this.invoice.trackingStatus;
    this.newStatus =
      this.invoice.trackingStatus;
  }


  ngAfterViewInit(): void {

  }


  ngOnInit(): void {

    this.buildForm();

    this.loadStatusList();

    this.fillForm();
  }


  ngOnDestroy(): void {

    if (this.subscription) {

      this.subscription.unsubscribe();
    }
  }


  /**
   * Retourne les codes motifs autorisés
   * pour le statut sélectionné.
   */
  getReasonCodesForStatus(
    statusCode: string
  ): SupplierInvoiceStatusReason[] {

      if (
          statusCode === undefined
          || statusCode === null
          || statusCode === ''
      ) {

          return [];
      }

      const statusCodeString =
          String(statusCode);

      const reasons =
          SUPPLIER_INVOICE_STATUS_REASONS
              .filter(
                  reason =>
                      reason.statuses.includes(
                          statusCodeString
                      )
              );

      reasons.sort(
          (
              reasonA,
              reasonB
          ) => {

              const labelA =
                  this._translate
                      .instant(
                          reasonA.code
                      );

              const labelB =
                  this._translate
                      .instant(
                          reasonB.code
                      );

              return labelA
                  .localeCompare(
                      labelB,
                      undefined,
                      {
                          sensitivity: 'base'
                      }
                  );
          }
      );

      reasons.unshift({
          code: '',
          statuses: [
              statusCodeString
          ]
      });

      return reasons;
  }


  /**
   * Construit le formulaire.
   */
  buildForm(): void {

    this.invoiceStatusForm =
      this.fb.group({

        invoiceStatusCur:
          this.fb.control({
            value: '',
            disabled: true
          }),

        invoiceStatusNew:
          this.fb.control({
            value: ''
          }),

        reasonCode:
          this.fb.control({
            value: '',
            disabled: true
          }),

        reason:
          this.fb.control({
            value: '',
            disabled: true
          })
      });
  }


  /**
   * Charge la liste des statuts fournisseurs.
   */
  loadStatusList(): void {

    this.invoiceStatusList = [];

    const supplierInvoiceStatuses:
      InvoiceStatusDefinition[] =
        INVOICE_STATUSES.filter(
          status =>
            status.supplier
        );

    for (
      const status of supplierInvoiceStatuses
    ) {

      const curLabel: LabelValue = {

        label:
          this._translate.instant(
            status.code.toString()
          ),

        value:
          status.code,

        otherData:
          null,

        disabled:
          status.code ===
          Number(this.currentStatus)
      };

      this.invoiceStatusList.push(
        curLabel
      );
    }
  }


  /**
   * Initialise le formulaire.
   */
  fillForm(): void {

    if (
      this.invoiceStatusForm === undefined
      || this.invoiceStatusForm === null
    ) {

      return;
    }


    this.invoiceStatusForm
      .controls
      .invoiceStatusCur
      .setValue(
        this.getStatusLabel(
          this.currentStatus
        )
      );


    this.invoiceStatusForm
      .controls
      .invoiceStatusNew
      .setValue(
        this.currentStatus
      );


    this.updateReasonRequirement(
      this.currentStatus
    );
  }


  /**
   * Retourne le libellé d'un statut.
   */
  getStatusLabel(
    status: string
  ): string {

    if (
      status === undefined
      || status === null
    ) {

      return '';
    }


    for (
      const item of this.invoiceStatusList
    ) {

      if (
        item.value ===
        Number(status)
      ) {

        return item.label;
      }
    }


    return status;
  }


  /**
   * Détermine si le statut sélectionné
   * nécessite un motif.
   */
  updateReasonRequirement(
    statusCode: string
  ): void {

      const status:
          InvoiceStatusDefinition =
          INVOICE_STATUSES.find(
              item =>
                  item.code ===
                  Number(statusCode)
          );

      this.requiresReason =
          status !== undefined
          && status.requiresReason === true;

      const reasonCodeControl =
          this.invoiceStatusForm
              .controls
              .reasonCode;

      const reasonControl =
          this.invoiceStatusForm
              .controls
              .reason;

      this.reasonCodeList =
          this.getReasonCodesForStatus(
              statusCode
          );

      if (this.requiresReason) {

          reasonCodeControl.enable();
          reasonCodeControl.clearValidators();
          reasonCodeControl.setValue('');
          reasonControl.enable();
          reasonControl.clearValidators();
          reasonControl.setValue('');

      } else {

          reasonCodeControl.setValue('');
          reasonCodeControl.clearValidators();
          reasonCodeControl.disable();
          reasonControl.setValue('');
          reasonControl.clearValidators();
          reasonControl.disable();
      }

      reasonCodeControl.updateValueAndValidity();
      reasonControl.updateValueAndValidity();
  }


  /**
   * Gestion du changement de statut.
   */
  onChangeInvoiceStatus(
    value: any
  ): void {

    this.newStatus =
      value;

    this.updateReasonRequirement(
      value
    );
  }


  /**
   * Gestion du changement de code motif.
   *
   * Le libellé traduit du code est automatiquement
   * placé dans le champ reason.
   */
  /**
 * Gestion du changement de code motif.
 *
 * Le libellé traduit du code est automatiquement
 * placé dans le champ reason.
 */
  onReasonCodeChange(
    reasonCode: string
  ): void {

      const reasonControl =
          this.invoiceStatusForm
              .controls
              .reason;

      if (
          reasonCode === undefined
          || reasonCode === null
          || reasonCode === ''
      ) {

          reasonControl
              .setValue('');

          reasonControl
              .enable();

          return;
      }

      const label =
          this._translate.instant(
              reasonCode
          );

      reasonControl
          .setValue(
              label
          );

      reasonControl
          .disable();
  }


  /**
   * Retourne le code motif actuellement sélectionné.
   */
  getSelectedReasonCode(): string {

    return this.invoiceStatusForm
      .controls
      .reasonCode
      .value;
  }


  /**
   * Retourne le motif actuellement affiché.
   */
  getSelectedReason(): string {

    return this.invoiceStatusForm
      .controls
      .reason
      .value;
  }


  /**
   * Vérifie la validité du formulaire.
   */
  isValid(): boolean {

    if (
      !this.invoiceStatusForm
    ) {

      return false;
    }


    if (
      this.requiresReason
      && !this.getSelectedReasonCode()
    ) {

      return false;
    }


    return this.invoiceStatusForm
      .valid;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

  onOKClick(): void {

    if (!this.isValid()) {

        this.invoiceStatusForm.markAllAsTouched();

        return;
    }

    const result = this.getResult();

    this.dialogRef.close({

        action: 'okAction',

        trackingStatus:
            result.trackingStatus,

        reasonCode:
            result.reasonCode,

        reason:
            result.reason
      });
  }

  /**
   * Ferme la fenêtre sans enregistrer.
   */
  onCancel(): void {

    this.dialogRef.close();
  }


  /**
   * Retourne les données à transmettre
   * au composant appelant.
   */
  getResult(): any {

    return {

        trackingStatus:
            this.invoiceStatusForm
                .controls
                .invoiceStatusNew
                .value,

        reasonCode:
            this.getSelectedReasonCode(),

        reason:
            this.getSelectedReason()
      };
  }
}
